"use strict";

(function () {
  'use strict';

  angular.module('lr.properties.filters').factory('formFilters', filters);
  filters.$inject = [];
  /* @ngInject */

  function filters() {
    var service = {
      getData: getData
    };
    return service; ////////////////

    function getData() {
      return {
        'Arrivals': false,
        'Departures': false,
        'Occupied': false,
        'Unoccupied': false,
        'ReadyState': false,
        'InProgressState': false,
        'PendingState': false,
        'Keyword': null // changed this to null because brian d said it was breaking the sql as false - @joshhurst 8/6/2015

      };
    }
  }
})();